export default [
    {
        path: 'relatorio-quantitativo-atendimento',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-atendimento' */
            '@/views/ambulatorio/relatorio-quantitativo-atendimento/Index'
        ),
        redirect: 'relatorio-quantitativo-atendimento/index',
        children: [
            {
                name: 'ambulatorio-relatorio-quantitativo-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-atendimento' */
                    '@/views/ambulatorio/relatorio-quantitativo-atendimento/List.vue'
                ),
            },
        ],
    },
]